export enum MapViewType {
    // DEFAULT = 'default',
    ROADMAP = 'roadmap',
    HYBRID = 'hybrid',
    SATELLITE = 'satellite',
    TERRAIN = 'terrain',
    WORLD_MAP = 'world_map'
}
